'use client';
import { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicEffect } from '@s7/hooks';
import { useProps } from '@s7/styles';
import { isString } from '@s7/utils';
import { IDENT, defaultProps } from './Portal.contract.js';

let commonTarget = null;
let portalCount = 0;
const getOrCreateTargetNode = (target)=>{
    if (target) {
        return isString(target) ? document.querySelector(target) : target;
    }
    if (!commonTarget) {
        const _target = document.createElement('div');
        _target.id = 'ds-common-portal-root';
        commonTarget = _target;
        document.body.appendChild(_target);
        return _target;
    }
    return commonTarget;
};
const Portal = (props)=>{
    const [{ target, children }] = useProps(IDENT, props, defaultProps);
    const [mounted, setMounted] = useState(false);
    const targetRef = useRef(null);
    useIsomorphicEffect(()=>{
        setMounted(true);
        targetRef.current = getOrCreateTargetNode(target);
        portalCount += 1;
        return ()=>{
            portalCount -= 1;
            if (!target && commonTarget && portalCount === 0) {
                document.body.removeChild(commonTarget);
                commonTarget = null;
            }
        };
    }, [
        target
    ]);
    if (!mounted) {
        return null;
    }
    return /*#__PURE__*/ createPortal(children, targetRef.current);
};
Portal.displayName = IDENT;
var Portal$1 = Portal;

export { Portal, Portal$1 as default };
//# sourceMappingURL=Portal.js.map
